import React from 'react';
import { C } from '../constants';

export default function ProgressBar({ progress, duration }) {
  if (!duration || duration === 0) return null;
  const pct = Math.min((progress / duration) * 100, 100);
  return (
    <div style={{ height:'3px', background:'rgba(255,255,255,0.1)', borderRadius:'2px', marginTop:'8px' }}>
      <div style={{ height:'100%', width:`${pct}%`, background:`linear-gradient(90deg, ${C.accent}, ${C.accentSoft})`, borderRadius:'2px' }} />
    </div>
  );
}
